import { format, isSameDay } from "date-fns"
import { RiDropLine } from "@remixicon/react"

import { weatherIconFromCode } from "@/app/home/utils/weatherIcon"
import type { WeatherDaily } from "@/hooks/api/useWeatherQuery"

interface ActivityWeekDayHeaderProps {
  date: Date
  weather?: WeatherDaily
  isMatchDay?: boolean
}

/**
 * timeGridWeek 의 dayHeaderContent 로 렌더링되는 요일 헤더.
 * 상단: 요일 약어 + 일자 (오늘이면 강조) + 매치데이 표시
 * 하단: 날씨 아이콘 + minTemp/maxTemp + humidity
 */
export default function ActivityWeekDayHeader({
  date,
  weather,
  isMatchDay,
}: ActivityWeekDayHeaderProps) {
  const isToday = isSameDay(date, new Date())

  return (
    <div className="ActivityWeekView__day-header">
      <div className="ActivityWeekView__day-header-row">
        <span className="ActivityWeekView__weekday">{format(date, "EEE").toUpperCase()}</span>
        <span className={`ActivityWeekView__day ${isToday ? "ActivityWeekView__day--today" : ""}`}>
          {format(date, "d")}
        </span>
        {isMatchDay && <span className="ActivityWeekView__md-chip">MD</span>}
      </div>
      <div className="ActivityWeekView__weather">
        {weather ? (
          <>
            <span className="ActivityWeekView__weather-icon">
              {weatherIconFromCode(weather.weatherCode, 14)}
            </span>
            <span>
              {formatTemp(weather.tempMin)} / {formatTemp(weather.tempMax)}
            </span>
            <span className="ActivityWeekView__humidity-icon">
              <RiDropLine size={8} />
            </span>
            <span className="ActivityWeekView__humidity">{formatHumidity(weather.humidity)}</span>
          </>
        ) : (
          <span className="ActivityWeekView__weather-placeholder">&nbsp;</span>
        )}
      </div>
    </div>
  )
}

function formatTemp(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "--"
  }

  return `${Math.round(value)}°`
}

function formatHumidity(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "--%"
  }

  return `${Math.round(value)}%`
}
